<template>
    <div class="pagesContent">
        <el-card>
            <div style="display: flex;justify-content: space-between;align-items: center;">
                <el-form ref="Search" :model="query" label-width="100px" inline>
                    <el-form-item label="公司编号">
                        <el-input v-model="query.CompanyId" placeholder="请输入公司编号" size="small" @change="searchSubmit"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称">
                        <el-input v-model="query.LikeCompanyName" placeholder="请输入公司名称" size="small" @change="searchSubmit">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="软件编号">
                        <el-input v-model="query.SoftwareId" placeholder="请输入公司名称" size="small" @change="searchSubmit">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div>
                    <el-button type="primary" @click="errorDiglog=true">添加错误信息</el-button>
                </div>
            </div>
        </el-card>
        <el-card style="margin-top: 10px;" class="card-box section">
            <el-table size="mini" :data="errorData" highlight-current-row stripe>
                <el-table-column prop="CompanyId" label="公司编号" width="200"/>
                <el-table-column prop="SoftwareId" label="软件编号" width="100"/>
                <el-table-column prop="LocalVersion" label="本机版本号" width="150"/>
                <el-table-column prop="ServerVersion" label="服务器版本号" width="150"/>
                <el-table-column prop="ErrorText" label="错误信息">
                    <template slot-scope='scope'>
                        <el-popover placement="top-start" width="1000" trigger="hover">
                            <span>{{scope.row.ErrorText}}</span>
                            <span slot="reference">{{scope.row.ErrorText.substr(0,100) + '...'}}</span>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="100">
                    <template slot-scope="scope">
                        {{scope.row.CreateTime | dateYMDFormat}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="errorLogDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="padding-top: 10px;" background :current-page.sync="query.pageIndex" :page-size.sync="query.pageSize"
                :page-sizes="[10, 20, 40, 50]" layout="total,sizes, prev, pager, next" :total="total"
                @size-change="getErrorlog" @current-change="getErrorlog">
            </el-pagination>
        </el-card>
        <el-dialog :visible.sync="errorDiglog" @close='()=>{formData = $options.data.call(this).formData}'>
            <el-form label-position="left" label-width="120px" :model="formData" ref="formData">
                <el-form-item label="公司编号">
                    <el-input v-model="formData.CompanyId"></el-input>
                </el-form-item>
                <el-form-item label="软件编号">
                    <el-input v-model="formData.SoftwareId"></el-input>
                </el-form-item>
                <el-form-item label="本机版本号">
                    <el-input v-model="formData.LocalVersion"></el-input>
                </el-form-item>
                <el-form-item label="服务器版本号">
                    <el-input v-model="formData.ServerVersion"></el-input>
                </el-form-item>
                <el-form-item label="错误信息">
                    <el-input type="textarea" v-model="formData.ErrorText"></el-input>
                </el-form-item>
                <el-form-item label="错误信息Hash">
                    <el-input type="textarea" v-model="formData.ErrorTextHash"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="errorDiglog = false">取 消</el-button>
                <el-button type="primary" @click="submigErrorLog">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            query:{
                CompanyId:'',
                LikeCompanyName:'',
                SoftwareId:'',
                pageIndex:1,
                pageSize:10
            },
            total:null,
            errorData:[],
            errorDiglog:false,
            formData:{
                CompanyId:'',
                SoftwareId:'',
                LocalVersion:'',
                ServerVersion:'',
                ErrorText:'',
                ErrorTextHash:'',
            },
        }
    },
    mounted(){
        this.getErrorlog()
    },
    methods:{
        errorLogDelete(itm){
            let data = `?id=${itm.Id}`
            this.$http.deleteErrorLog(data).then(res=>{
                console.log(res)
                if(res.status==200){
                    this.$message.success('删除成功')
                    this.getErrorlog()
                }else{
                    this.$message('删除失败')
                }
            })
        },
        submigErrorLog(){
          this.$http.addErrorLog(this.formData).then(res=>{
            console.log(res)
          })  
        },
        getErrorlog(){
            this.$http.getAllErrorLog(this.query.pageIndex,this.query.pageSize,this.query).then(res=>{
                console.log(res)
                if(res.status==200){
                    this.errorData = res.data.Items
                    this.total = res.data.TotalCount
                }else{
                    this.$message.error('查询失败')
                }
            })
        },
        
    }
}
</script>
<style>
    .card-box {
		margin-bottom: 40px;
	}
    .el-tooltip__popper {
        max-width: 700px;
    }
</style>